module.exports = __webpack_public_path__ + "static/media/SmartStock_Vertical_App.e7b5bb79.png";